import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//--
import { InterfaceService } from '@app/interfaces';
import { BehaviorSubject } from 'rxjs';
import { window } from "ngx-bootstrap";
import { SettingsService } from "@app/core";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CommonService = /** @class */ (function (_super) {
    tslib_1.__extends(CommonService, _super);
    function CommonService(http, injector) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.injector = injector;
        _this.currentUser = new BehaviorSubject(false);
        _this.$currentUser = _this.currentUser.asObservable();
        _this.mailModalCase = new BehaviorSubject(false);
        _this.$mailModalCase = _this.mailModalCase.asObservable();
        return _this;
    }
    /* Get client country code
        Response : {"countryName":"STRING<country-name>"}
    */
    CommonService.prototype.getClientCountryCodes = function (params) {
        return this.http.get(this.getApiUrl("get_client_country_code", params));
    };
    /* Set new job phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    CommonService.prototype.setNewJobPhoneCall = function (type, customerId, jobId, mode, data, params) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + customerId + "/notes/jobs/" + jobId + "/new_phone_call/" + mode, params), JSON.stringify(data));
    };
    /* Set new estimate phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    CommonService.prototype.setNewEstimatePhoneCall = function (type, customerId, estimateId, mode, data, params) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + customerId + "/notes/estimate/" + estimateId + "/new_phone_call/" + mode, params), JSON.stringify(data));
    };
    /* Set new estimate phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    CommonService.prototype.setNewCustomerPhoneCall = function (type, customerId, mode, data, params) {
        return this.http.post(this.getApiUrl(type + "/new_phone_call/" + customerId + "/" + mode, params), JSON.stringify(data));
    };
    /* Set new invoice phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    CommonService.prototype.setNewInvoicePhoneCall = function (type, customerId, jobId, invoiceId, mode, data, params) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + customerId + "/notes/jobs/" + jobId + "/invoices/" + invoiceId + "/new_phone_call/" + mode, params), JSON.stringify(data));
    };
    /* get infobar details from communications
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    CommonService.prototype.getInfoBarDetails = function (Id, tableType) {
        return this.http.get(this.getApiUrl("getInfoBarDetails?id=" + Id + "&type=" + tableType));
    };
    /* get print and post credits */
    CommonService.prototype.getCheckPrintPostCredits = function () {
        return this.http.get(this.getApiUrl("check_print_post_credits"));
    };
    /* process print and post */
    CommonService.prototype.printAndPostService = function (type, id) {
        return this.http.get(this.getApiUrl("process_printpost?tableType=" + type + "&tablePKID=" + id + "&type=print_post"));
    };
    CommonService.prototype.saveUserNewUIPreference = function (data) {
        return this.http.post(this.getApiUrl("saveUserNewUIPreference"), data);
    };
    /* postcode details call*/
    CommonService.prototype.getPostCodeService = function (postcode) {
        return this.http.get(this.getApiUrl("search_postcode?postcode=" + postcode));
    };
    /* Get county list */
    CommonService.prototype.getCountiesList = function () {
        return this.http.get(this.getApiUrl("get_state_provinces"));
    };
    /*save county*/
    CommonService.prototype.saveNewCounty = function (data) {
        return this.http.post(this.getApiUrl("save_province"), data);
    };
    /* save new landlords */
    CommonService.prototype.saveNewLandlords = function (data) {
        return this.http.post(this.getApiUrl("landlord_create"), data);
    };
    /* save new workaddress */
    CommonService.prototype.saveNewWorkaddress = function (id, type, data) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + id + "/work/new_works"), data);
    };
    /* Check unique county */
    CommonService.prototype.checkUniqueCounty = function (province) {
        return this.http.get(this.getApiUrl("is_province_exists?province=" + province));
    };
    CommonService.prototype.postNewInvoiceAddress = function (id, type, data) {
        return this.http.post(this.getApiUrl("customers/" + type + "/" + id + "/invoice_address_v2/new"), data);
    };
    CommonService.prototype.getCurrentUser = function () {
        var _this = this;
        var url = this.getApiUrl("get_current_user");
        this.http.get(url).subscribe(function (result) {
            if (result) {
                _this.setCurrentUser(result);
            }
        });
    };
    CommonService.prototype.setCurrentUser = function (data) {
        this.currentUser.next(data);
    };
    CommonService.prototype.updateNewInvoiceAddress = function (data) {
        return this.http.post(this.getApiUrl("invoiceAddressUpdate"), data);
    };
    CommonService.prototype.getUsersList = function (data) {
        if (data === void 0) { data = {}; }
        var url = this.getApiUrl("get_clientUsers", data);
        return this.http.get(url);
    };
    CommonService.prototype.getClientUsersList = function () {
        var url = this.getApiUrl("get_client_users");
        return this.http.get(url);
    };
    CommonService.prototype.getViewersInfo = function (data) {
        return data ? {
            imageSource: data['imageSource'] || 'images/profile_avatar_small.jpg',
            name: data['name'] || null
        } : null;
    };
    /*To avoid empty spaces are allowed as valid formvalue*/
    CommonService.prototype.whitespaceValidator = function (control) {
        var trimmedControlValue = (control.value || '').trim();
        return trimmedControlValue == '' ? { 'required': true } : null;
    };
    ;
    CommonService.prototype.setMailModalCase = function (data) {
        this.mailModalCase.next(data);
    };
    CommonService.prototype.getIsUserActive = function (id) {
        var url = this.getApiUrl("getIsUserActive?userId=" + id);
        return this.http.get(url);
    };
    CommonService.prototype.getJobOnHoldDescription = function () {
        var url = this.getApiUrl("getJobOnHoldDescription");
        return this.http.get(url);
    };
    CommonService.prototype.postPostHogDetails = function (event, paramaters) {
        var settings = this.injector.get(SettingsService);
        var accountType = settings.accountType;
        if (window['posthog'] && accountType == 5) {
            posthog.capture(event, {
                paramaters: paramaters
            });
        }
    };
    CommonService.ngInjectableDef = i0.defineInjectable({ factory: function CommonService_Factory() { return new CommonService(i0.inject(i1.HttpClient), i0.inject(i0.INJECTOR)); }, token: CommonService, providedIn: "root" });
    return CommonService;
}(InterfaceService));
export { CommonService };
